/* eslint-disable max-len */
/* eslint-disable security/detect-unsafe-regex */

import React, { Fragment, useRef, useState } from 'react'
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick'

export default function StudentListPopup({
    setViewStudentList, 
    studentIdArray,
    setStudentIdArray,
    setToastErrorMessage,
    studentAllData}) {
    const closeRef = useRef();
    const [selectedAllId, setSelectedAllId] = useState(studentIdArray)
    useOnClickOutside(closeRef,()=>{
        setViewStudentList(false)
    })
    const [isAllSelected, setIsAllSelected] = useState(studentIdArray?.length === studentAllData?.length)
    const [noStudentsError,setNoStudentsError] = useState(false)
    const [noStudentsMsg,setNoStudentsErrorMsg] = useState('')
    const handelAllId = () => {
        if(!isAllSelected) {
            setIsAllSelected(true)
            setSelectedAllId(studentAllData.map(obj => obj.student_id))
        } else {
            setIsAllSelected(false)
            setSelectedAllId([])
        }
    }
    const handleCheckbox = (id) => {
        if (selectedAllId.includes(id)) {
            // If the ID is included, remove it
            const updatedArray = selectedAllId.filter((studentId) => studentId !== id);
            setIsAllSelected(false)
            setSelectedAllId(updatedArray);
        } else {
            // If the ID is not included, add it
            setIsAllSelected(selectedAllId?.length + 1 === studentAllData?.length)
            setSelectedAllId([...selectedAllId, id]);
        }
        setNoStudentsError(false)
    };
    const handleStudentIdUpdate = () => {
        if(selectedAllId?.length === 0) {
            setNoStudentsError(true)
            setNoStudentsErrorMsg('Select atleast 1 student')
            return true;
        } else {
            setNoStudentsError(false)
            setStudentIdArray(selectedAllId);
            setViewStudentList(false);
        }
    }
    return (
        <div data-te-modal-init  className={`fixed left-0 top-0 z-[1055] bg-[#00000047]  ${true ? '' : 'hidden'} h-full w-full overflow-y-auto overflow-x-hidden outline-none `} id="descriptionModal" tabindex="-1" aria-labelledby="descriptionModal" aria-modal="true" role="dialog">
            <div data-te-modal-dialog-ref className="pointer-events-none relative left-[100px] top-[100px] flex min-h-[400px] translate-y-[-50px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[656px] mx-auto max-w-[656px]">
                <div ref={closeRef} className="pointer-events-auto flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600 mx-auto relative">
                    <div class="flex flex-shrink-0 items-center rounded-t-md bg-blue-50 py-2 px-3">
                        <p class="text-lg font-medium text-[#031624] text-center">Select Students</p>
                        <button 
                            type="button" 
                            class="absolute right-3 box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                            data-te-modal-dismiss aria-label="Close"
                            onClick={() => {setViewStudentList(false); }}
                        >
                            <img loading="lazy" decoding="async" src="/images/modalClose.svg" alt="icon" />
                        </button>
                    </div>
                    <div class="my-2">
                        {noStudentsError && <p class="text-sm text-red-500 w-full text-center absolute">{noStudentsMsg}</p>}
                        <div className='max-h-maxHeight2 overflow-auto scroll-bar px-4 w-full relative mt-2'>
                            <div className='mb-2 relative' id='search-result'>
                                <table className="w-full table-auto stickyhead" id="admin-table">
                                    <thead>
                                        <tr className='student-th'>
                                            <th class="w-[5%]">
                                                <div className={`relative checkbox custom-checkBoxBlue1`}>
                                                    <input type="checkbox" id="all_id" checked={isAllSelected} onChange={() => handelAllId()} />
                                                    <label htmlFor="all_id" className="text-sm font-normal text-[#031624] w-full cursor-pointer"></label>
                                                </div>
                                            </th>
                                            <th class="w-[25%]">
                                                <span class="flex items-center justify-start  font-semibold text-[#031624] pl-2">Student ID
                                                </span>
                                            </th>
                                            <th class="w-[25%]">
                                                <span class="flex items-center justify-start  font-semibold text-[#031624]">Student Name
                                                </span>
                                            </th>
                                            <th class="w-[20%]">
                                                <span class="flex items-center justify-start  font-semibold text-[#031624]">Class
                                                </span>
                                            </th>
                                            <th class="w-[20%]">
                                                <span class="flex items-center justify-start  font-semibold text-[#031624]">Section
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {studentAllData.map((item) => <Fragment key={item._id}>
                                            <tr className='border-t border-[#D0D5DD]'></tr>
                                            <tr>
                                                <td class="">
                                                    <div className={`relative checkbox custom-checkBoxBlue1`}>
                                                        <input
                                                            type="checkbox"
                                                            id={item.student_id}
                                                            checked={selectedAllId.includes(item.student_id)}
                                                            onChange={() => handleCheckbox(item.student_id)}
                                                        />
                                                        <label htmlFor={item.student_id} className="text-sm font-normal text-[#031624] w-full cursor-pointer"></label>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <div className='flex items-center '>
                                                        <p className='  pl-2'>{item?.student_id}</p>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <span  title={item?.full_name}>{item?.full_name}</span>
                                                </td>
                                                <td class="">
                                                    <span  title={item?.classes.class_name}>{item?.classes.class_name}</span>
                                                </td>
                                                <td class="">
                                                    <span  title={item?.sections?.section_name}>{item?.sections?.section_name}</span>
                                                </td>
                                            </tr>
                                        </Fragment>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='flex items-center justify-center my-3'>
                        <button 
                            type='button' 
                            className='cancl-btn1'
                            onClick={() => {setViewStudentList(false); }}
                        >Cancel</button>
                        <button 
                            type='button' 
                            onClick={() => handleStudentIdUpdate()}
                            className='actn-btn1'
                        >OK</button>
                    </div>
                </div>
            </div>
        </div>
    )
}